import {ApiClient} from './ApiClient';

export const getBusinessService = async (businessId: number, jwt: string) => {
  const apiUrl = `/business/${businessId}`;
  return await ApiClient(apiUrl, jwt).get();
};
